export default __webpack_public_path__ + "static/media/favicon.8c588955.ico";